import { render } from "./MaterialItem.vue?vue&type=template&id=41b1f4df"
import script from "./MaterialItem.vue?vue&type=script&lang=js"
export * from "./MaterialItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__